export const convertDateFormat = (dateStr) => {
    let fullDateMatch = dateStr?.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (fullDateMatch) {
      let [_, month, day, year] = fullDateMatch;
      return { dateString: `${year}-${day}-${month}`, type: 'day' };
    }

    let monthYearMatch = dateStr?.match(/^(\d{2})\/(\d{4})$/);
    if (monthYearMatch) {
      let [_, month, year] = monthYearMatch;
      return { dateString: `${year}-${month}`, type: 'month' };
    }

    let yearMatch = dateStr?.match(/^(\d{4})$/);
    if (yearMatch) {
      return { dateString: `${yearMatch[1]}`, type: 'year' };
    }

    return 'Invalid date format';
  }
  export const convertDateFormatString = (dateStr) => {
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    let isoDateMatch = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (isoDateMatch) {
      let [_, year, month, day] = isoDateMatch;
      return `${months[parseInt(month) - 1]} ${parseInt(day)}, ${year}`;
    }

    let yearMonthMatch = dateStr.match(/^(\d{4})-(\d{2})$/);
    if (yearMonthMatch) {
      let [_, year, month] = yearMonthMatch;
      return `${months[parseInt(month) - 1]} ${year}`;
    }

    let monthYearMatch = dateStr.match(/^(\d{2})\/(\d{4})$/);
    if (monthYearMatch) {
      let [_, month, year] = monthYearMatch;
      return `${months[parseInt(month) - 1]} ${year}`;
    }

    let yearMatch = dateStr.match(/^(\d{4})$/);
    if (yearMatch) {
      return yearMatch[1];
    }

    return 'Invalid date format';
  }